import config from "src/config/config";

export const getImageUrl = (path: string) => `${config.baseUrl}${path}`;
